import KollectiveXHR from '../../interceptor/KollectiveXHR';
import logger from '../../log';
import { BindOptions } from '../interfaces';
import { HttpResponseType } from '../../interceptor/interfaces';
import { ViblastXhr } from './interfaces';

const log = logger.getLogger(__filename);

const modifyViblastRequest = (
  options: BindOptions,
  evt: ViblastXhr
): KollectiveXHR => {
  log.trace('modifyViblastRequest:', { evt, options });
  const ourXhr = new KollectiveXHR(options);
  ourXhr.responseType = evt.xhr.responseType;

  // Replace necessary parts of the xhr object so that we can functionally
  // replace it.
  Object.defineProperty(evt.xhr, 'responseType', {
    get: () => ourXhr.responseType,
    set: (type: HttpResponseType) => {
      ourXhr.responseType = type;
    }
  });
  Object.defineProperty(evt.xhr, 'response', { get: () => ourXhr.response });
  Object.defineProperty(evt.xhr, 'responseText', {
    get: () => ourXhr.responseText
  });
  evt.xhr.send = ourXhr.send;
  if (evt.xhr.readyState === evt.xhr.OPENED) {
    ourXhr.open(evt.method, evt.url);
  } else {
    evt.xhr.open = ourXhr.open;
  }
  // NOTE: Our event listeners are functionally identical but syntactically
  // different so we need to declare ourXhr as unknown before declaring it as
  // XMLHttpRequest. 'xhr' will respond to all of the 'on' functions correctly.
  const xhr = (ourXhr as unknown) as XMLHttpRequest;
  xhr.onabort = evt.xhr.onabort;
  xhr.onerror = evt.xhr.onerror;
  xhr.onload = evt.xhr.onload;
  xhr.onloadend = evt.xhr.onloadend;
  xhr.onloadstart = evt.xhr.onloadstart;
  xhr.onreadystatechange = evt.xhr.onreadystatechange;
  return ourXhr;
};

export default modifyViblastRequest;
